// extracted by mini-css-extract-plugin
module.exports = {"featuredTopics":"TeamExpertiseList_featuredTopics__0_u_3","titleWithBorder":"TeamExpertiseList_titleWithBorder__s0fTo"};